var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 36,
    viewBox: "0 0 24 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v36l24-18z",
    fill: "#fff"
  })));
}

export default SvgPlayArrow;